import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CatalogItem, ConnectivityCatalogEntry, ConnectivityCatalogEntryGetRequest, ConnectivityFilters } from "src/app/domains/connectivity/models/connectivity.model";
import { ConnectivityService } from "src/app/domains/connectivity/services/connectivity.service";
import { Pagination } from "src/app/shared/components/table-pagination/table-pagination.model";
import { Paginated } from "src/app/shared/paginated.model";
import { NotificationService } from "src/app/shared/services/notification/notification.service";
import { AddConnectivityEntryComponent } from "../../components/add-connectivity-entry/add-connectivity-entry.component";
import { EditConnectivityEntryDocumentsComponent } from "../../components/edit-connectivity-entry-documents/edit-connectivity-entry-documents.component";
import { EditConnectivityEntryComponent } from "../../components/edit-connectivity-entry/edit-connectivity-entry.component";

@Component({
  templateUrl: './connectivity-main.component.html',
  styleUrls: ['./connectivity-main.component.scss']
})
export class ConnectivityMainComponent implements OnInit {

  public paginatedCatalogEntryList: Paginated<ConnectivityCatalogEntry>;
  public loadingCatalogList: boolean = false;

  public pagination: Pagination = {
    page: 0,
    empty: true,
    totalPages: 0
  };
  public pageSize: number = 30;
  public tableLoadingLines = new Array(this.pageSize).fill(0);

  constructor(
    private connectivityService: ConnectivityService,
    private modalService: NgbModal,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.getCatalogList();
  }

  public selectPageSize(size: number) {
    this.pageSize = size;
    this.tableLoadingLines = new Array(this.pageSize).fill(0);
    this.getCatalogList();
  }
  public changeCurrentPage(page: number) {
    this.pagination.page = page;
    this.getCatalogList();
  }

  public onAddCatalogEntry() {
    const modal = this.modalService.open(AddConnectivityEntryComponent, {
      size: 'lg'
    });

    modal.componentInstance.onSubmit.subscribe((item: CatalogItem) => {
      this.loadingCatalogList = true;
      this.connectivityService.addEntry(item).subscribe(() => {
        this.notificationService.success('connectivity.success-messages.success-add-entry');
        this.getCatalogList();
      }, () => {
        this.loadingCatalogList = false;
      });
    });
  }

  public onEditCatalogEntry(entry: ConnectivityCatalogEntry) {
    const modal = this.modalService.open(EditConnectivityEntryComponent, {
      size: 'lg'
    });

    modal.componentInstance.entryToEdit = {
      brand: entry.brand,
      model: entry.model,
      type: entry.type
    };

    modal.componentInstance.onSubmit.subscribe((item: CatalogItem) => {
      this.loadingCatalogList = true;
      this.connectivityService.editEntry(entry.id, item).subscribe(() => {
        this.notificationService.success('connectivity.success-messages.success-edit-entry');
        this.getCatalogList();
      }, () => {
        this.loadingCatalogList = false;
      });
    });
  }

  public onFiltersChanged(filters: ConnectivityFilters) {
    this.getCatalogList({
      ...filters
    })
  }

  public onEditEntryDocuments(entry: ConnectivityCatalogEntry) {
    const modal = this.modalService.open(EditConnectivityEntryDocumentsComponent, {
      size: 'lg'
    });

    modal.componentInstance.entry = entry;
    modal.closed.subscribe((reason: boolean) => {
      if (reason)
        this.getCatalogList();
    });
  }

  public onDeleteCatalogEntry(entry: ConnectivityCatalogEntry) {
    const result: Promise<string> = this.notificationService.showConfirmation('connectivity.delete-modal.text');
    result.then((reason: string) => {
      if (reason === 'ok') {
        this.connectivityService.deleteEntry(entry.id).subscribe(() => {
          this.notificationService.success('connectivity.success-messages.success-delete-entry');
          this.getCatalogList();
        });
      }
    })
  }

  private getCatalogList(params?: ConnectivityCatalogEntryGetRequest) {
    this.loadingCatalogList = true;
    params = params || {};
    const query: ConnectivityCatalogEntryGetRequest = {
      ...params,
      page: this.pagination.page,
      size: this.pageSize
    }
    this.connectivityService.getDevices(query).subscribe((response: Paginated<ConnectivityCatalogEntry>) => {
      this.paginatedCatalogEntryList = response;
      this.pagination = {
        empty: response.empty,
        page: response.pageable.pageNumber,
        totalPages: response.totalPages
      }
      this.loadingCatalogList = false;
    }, () => {
      this.loadingCatalogList = false;
    })
  }
}
